import React from 'react';
import { getUserProfilePic } from './helpers/detailRowHelpers';



export const TeamDetailModal = ({ entityName, teamData }) => {

    if (!teamData) {
        return null;
    }

    let modalData = [];
    teamData.map((teamMember, i) => {

        const userData = teamMember.user_data;
        const userImage = getUserProfilePic(userData);
        const username = `${userData.first_name} ${userData.last_name}`

        modalData.push(
            <div className="d-flex align-items-center" key={userData.id}>
                {userImage}
                <div style={{ marginLeft: 9 }}>
                    <div className="startup-name">
                        {username}
                    </div>
                </div>
            </div>
        )

    });

    return (
        <div className="modal fade" id={"teams-modal"} tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true" data-backdrop="false">
            <div className="filterBackground" data-dismiss="modal"></div>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Team - {entityName}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {modalData}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default TeamDetailModal;